import React, { useEffect } from 'react';

const AuthGuard = ({component}) => {
  
    return <React.Fragment>{component}</React.Fragment>
}

export default AuthGuard;